import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M20 12V8H6a2 2 0 0 1-2-2c0-1.1.9-2 2-2h12v4",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "M4 6v12c0 1.1.9 2 2 2h14v-4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M18 12a2 2 0 0 0-2 2c0 1.1.9 2 2 2h4v-4h-4z",
            stroke: `${color}`
          }
        )
      ]
    }
  );
};
Icon.displayName = "Wallet";
const Wallet = memo(themed(Icon));
export {
  Wallet
};
//# sourceMappingURL=wallet.js.map
